


























module.exports = {
  props:
    filters: {}
    item_options: {}
    item_class: {}
    options: {}
    prop_tooltip_placement:
      default: null
    origem:
      default: 'Tarefas'
    sort:
      default: ->
        (task_1, task_2) ->
          startTime = moment(task_1.due_on)
          endTime = moment(task_2.due_on)

          duration = moment.duration(startTime.diff(endTime))
          if duration.asMilliseconds() > 0
            task_1.due_on.isAfter(task_2.due_on) and 1 or -1
          else
            task_1.id > task_2.id and 1 or -1

  components:
    taskItem: require('./list_item')

  data: ->
    tasks: []
    loading: false
    next_page: 1
    total_count: 0
    disable_infinite_scroll: false
    current_company: Session.current_company
    element_options:
      tasks_status: 'all' # all, today, overdue

  methods:
    handleToggleDoneEvent: (task) ->
      if task.isDone()
        @tasks.remove(task.id)
      else
        @tasks.push task

    tasksList: ->
      @tasks

    loadTasks: ->
      return if @loading || !@next_page
      @loading = true
      @tasks_resource.index(@loadTasksSuccess, @unknownError, params: { q: @filters, company_id: @current_company.id, page: @next_page })

    reloadTasks: ->
      @loading = false
      @next_page = 1
      @tasks = []
      @loadTasks()

    loadTasksSuccess: (data) ->
      @tasks = @tasks.concat data.tasks
      @loading = false
      if data.meta
        @next_page = data.meta.next_page
        @total_count = data.meta.total_count
        @$emit 'number-of-tasks', @total_count

    taskUpdated: (task) ->
      return unless task.isDone()
      EventsBus.$emit 'Task::Done', task

    updateTasksList: (data) ->
      if !data.task.isDone()
        @tasks.replaceById(data.task)

    updateMetadata: (task) ->
      return if task.isDone()
      old_task = @tasks.find(task.id)
      if old_task
        old_task.metadata = task.metadata
        old_task.due_on = task.due_on
        @tasks.replaceById(old_task)

    canAddTaskToList: (task) ->
      return if @tasks.findIndex(task.id) > -1
      switch @element_options.tasks_status
        when 'today' then task.isDueToday()
        when 'overdue' then task.isOverdue() && !task.isDueToday()
        else true

    addTask: (task) ->
      return unless @canAddTaskToList(task)
      @tasks.push(task)
      @total_count++
      @$emit 'number-of-tasks', @total_count

    removeTask: (task) ->
      if (!task.metadata?.ozzy && @tasks.remove(task.id)) && task.id
        @total_count--
        @$emit 'number-of-tasks', @total_count

    mergeDefaultOptions: ->
      @element_options = Object.assign({}, @element_options, @options || {})

    initializeTasksResource: ->
      contact_id = @filters.filter_by_contact_id
      return new TasksResource unless contact_id
      @disable_infinite_scroll = true
      new ContactTasksResource(contact_id)

  computed:
    sorted_tasks: ->
      @tasks.sort(@sort)

  created: ->
    @mergeDefaultOptions()
    @tasks_resource = @initializeTasksResource()
    @loadTasks()
    EventsBus.$on 'Task::Undone', @addTask
    EventsBus.$on 'Task::Done', @removeTask
    EventsBus.$on 'Task::Remove', @removeTask
    EventsBus.$on 'Task::Updated', @updateTasksList
    EventsBus.$on 'Task::UpdatedMetadata', @updateMetadata

  beforeDestroy: ->
    EventsBus.$off 'Task::Undone', @addTask
    EventsBus.$off 'Task::Done', @removeTask
    EventsBus.$off 'Task::Remove', @removeTask
    EventsBus.$off 'Task::Updated', @updateTasksList
    EventsBus.$off 'Task::UpdatedMetadata', @updateMetadata
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/list.vue